import React from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'

import { Box, Button as MuiButton, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { MyServerTable } from './MyServerTable'

import { useLogic, useStore } from '../hooks/storeHook'

import { appRoutes } from '../common/appRoutes'
import { userColumns } from '../types/userColumns'
import { isAppTypeMpSklad } from '../common/isAppTypeMpSklad'
import { Button as MpCardButton } from '../mpCard/shared/ui/button'

export const AdminUsersScreen =
  observer(
    () => {
      const {user, adminStore: {users}} = useStore()
      const history = useHistory()

      const classes = useStyles()

      const logic = useLogic();

      if (!user?.isSuperAdmin) {
        return null
      }

      return (
        <div className="body_wrapper_zero">
          <div className="body_wrapper">
            <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" marginBottom={2}>
              <h1 className={classes.title}>
                Пользователи
              </h1>

              <Box display="flex" flexWrap="wrap" alignItems="center">
                <MuiButton
                  className={classes.navButton}
                  variant="outlined"
                  onClick={() => history.push(appRoutes.AdminMsAppLifecycle)}>
                  Статистика МС-приложения
                </MuiButton>

                {isAppTypeMpSklad() &&
                  <MuiButton
                    className={classes.navButton}
                    variant="outlined"
                    onClick={() => history.push(appRoutes.AdminRealizationReports)}>
                    Отчёты о реализации
                  </MuiButton>
                }

                <MuiButton
                  className={classes.navButton}
                  variant="outlined"
                  onClick={() => history.push(appRoutes.Account)}>
                  Аккаунт
                </MuiButton>
              </Box>
            </Box>
          </div>

          <div className="body_wrapper">
            <Box display="flex" alignItems="center">
              <input
                autoFocus
                className="main_input"
                type="text"
                placeholder="Поиск"
                onChange={e => users.setGlobalFilter(e.target.value)}
              />
            </Box>
          </div>

          <div className={classes.tableWrapper}>
            <Box display="flex">
              <Paper className={classes.paper}>
                <MyServerTable
                  table={users}
                  columns={userColumns}
                  labelNoRows="Пользователей нет"
                  labelNotFound="Пользователи не найдены"
                  labelRowsPerPage="Пользователей на странице:"
                />
              </Paper>
            </Box>
          </div>

          {!isAppTypeMpSklad() &&
            <div className="body_wrapper">
              <Box display="flex" alignItems="center" marginBottom={2}>
                <MpCardButton color="primary" onClick={() => logic.refreshCategories()}>
                  Обновить категории
                </MpCardButton>
              </Box>
            </div>}
        </div>
      )
    })

const useStyles =
  makeStyles(
    ({spacing}) => ({
      title: {
        margin: 0
      },
      tableWrapper: {
        display: 'flex',
        width: 'fit-content'
      },
      paper: {
        width: 'calc(-300px + 100vw)'
      },
      navButton: {
        marginRight: spacing(1),
        marginBottom: spacing(1)
      }
    }))